import React from 'react';
import { Navigate } from 'react-router-dom';
import {isAuthenticated} from './auth';

export const ProtectedRoute = ({ element }) => {
    if (!isAuthenticated()) {
      return <Navigate to="/" replace />;
    } 
    return element;
  };